import { useEffect } from "@wordpress/element";
import MenuItem from "@mui/material/MenuItem";
import { SelectField } from "vino/core";
import { useDispatch, useSelector } from "react-redux";
import { getStateList } from "store/vino/lookupsSlice";

const State = ({ countryId, ...props }) => {
	const dispatch = useDispatch();
	const states = useSelector(({ vino }) => vino.lookups.states);
	const stateList = states[countryId];
	useEffect(() => {
		if (countryId && !states[countryId]) {
			dispatch(getStateList(countryId));
		}
	}, [dispatch, countryId]);

	return (
		<SelectField {...props} fullWidth label="State">
			<MenuItem value="">Select</MenuItem>
			{stateList &&
				stateList.map((state) => (
					<MenuItem key={state.id} value={state.id}>
						{state.name}
					</MenuItem>
				))}
		</SelectField>
	);
};

export default State;
